import {
  DashboardModule, Form,
} from '@domain-group/suit-theme'

import { useCampaignQuoteTemplateForm } from '@hooks/useCampaignQuoteTemplate'

import EntitySelector from '@components/EntitySelector'

interface CampaignQuoteTemplateDetailsProps {
  campaignQuoteTemplateFormPayload: ReturnType<typeof useCampaignQuoteTemplateForm>,
}

const CampaignQuoteTemplateDetails = (props: CampaignQuoteTemplateDetailsProps) => {
  const {
    campaignQuoteTemplateFormPayload: {
      entityState: {
        agency_id,
        title,
      },
      errors,
      handlers,
      setEntityState,
    },
  } = props

  return (
    <DashboardModule title="Quote Template Details">
      <Form padding="large">
        <Form.Row>
          <Form.Field errorMessage={errors.title} label="* Title">
            <input
              name="title"
              value={title}
              type="text"
              {...handlers}
            />
          </Form.Field>

          <EntitySelector
            callbacks={{
              selectItem: agency => setEntityState({ agency_id: agency?.id }),
            }}
            entityKey="agencies"
            label="* Agency"
            selectedItemId={agency_id}
          />
        </Form.Row>
      </Form>
    </DashboardModule>
  )
}

export default CampaignQuoteTemplateDetails
